<script setup lang="ts">
import type { PropType } from 'vue'

export type Color = 'orange' | 'green' | 'blue' | 'gray' | 'gold'
export type Size = 'small' | 'normal' | 'large'

interface TagProps {
  color: Color
  size: Size
}

const props: TagProps = defineProps({
  color: {
    type: String as PropType<Color>,
    default: 'gray',
  },
  size: {
    type: String as PropType<Size>,
    default: 'normal',
  },
})
const { color, size = 'normal' } = props
function status(color: Color) {
  return `tag-status-${color}`
}
function getSize(size: Size) {
  if (size === 'normal')
    return ''
  return `tag-${size}`
}
</script>

<template>
  <div :class="`tag ${status(color)} ${getSize(size as Size)}`">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import './index.module.scss';
</style>
